import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function BirthDataForm({ birth, onSaved }) {
  const [form, setForm] = useState({
    birth_date: birth?.birth_date || "", birth_time: birth?.birth_time || "", birth_place: birth?.birth_place || "",
  });
  const [editing, setEditing] = useState(!birth);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/me/birth", form);
      onSaved(data);
      setEditing(false);
      toast.success("Tu carta natal está guardada ✦");
    } catch (err) { toast.error(errMsg(err, "No se pudo calcular tu carta")); }
    finally { setSaving(false); }
  };

  if (!editing) {
    return (
      <div data-testid="birth-summary" className="flex flex-wrap items-center gap-x-10 gap-y-4">
        {[["Fecha", birth.birth_date.split("-").reverse().join("/")], ["Hora", birth.birth_time],
          ["Lugar", birth.display_name || birth.birth_place]].map(([k, v]) => (
          <div key={k}><p className="field-label">{k}</p><p className="text-white">{v}</p></div>
        ))}
        <button data-testid="birth-edit" onClick={() => setEditing(true)} className="btn-ghost text-sm">Editar</button>
      </div>
    );
  }

  return (
    <form onSubmit={save} data-testid="birth-form" className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl">
      <div><label className="field-label">Fecha de nacimiento</label>
        <input data-testid="birth-date" type="date" required className="input-field" value={form.birth_date} onChange={set("birth_date")} /></div>
      <div><label className="field-label">Hora exacta</label>
        <input data-testid="birth-time" type="time" required className="input-field" value={form.birth_time} onChange={set("birth_time")} /></div>
      <div><label className="field-label">Ciudad de nacimiento</label>
        <input data-testid="birth-place" required placeholder="Ciudad, País" className="input-field" value={form.birth_place} onChange={set("birth_place")} /></div>
      <div className="md:col-span-3 flex gap-3">
        <button data-testid="birth-save" type="submit" disabled={saving} className="btn-lilac">
          {saving ? "Calculando…" : "Guardar y calcular mi carta ✦"}
        </button>
        {birth && <button type="button" data-testid="birth-cancel" onClick={() => setEditing(false)} className="btn-ghost text-sm">Cancelar</button>}
      </div>
    </form>
  );
}
